import React, { useEffect, useState, useMemo, useRef } from "react";
import api from "../../api/api";
import { Select } from "../../components/Select";
import { Input } from "../../components/Input";
import moment from "moment";
import { CircularProgress } from "@mui/material";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  LineChart,
  AreaChart,
  Area,
  Cell,
  Label,
  LabelList,
} from "recharts";
import { HorizontalChart } from "../../components/HorizontalChart";
import logo from "../../assets/images/logo-sm.png";
import {
  MdChangeCircle,
  MdDownload,
  MdFileOpen,
  MdFilePresent,
  MdFirstPage,
  MdGavel,
  MdGroups,
  MdPages,
} from "react-icons/md";
import { Button } from "../../components/Button";
import { toast } from "react-toastify";
import {
  HiOutlineCheck,
  HiOutlinePencil,
  HiOutlinePlus,
  HiOutlineTrash,
  HiOutlineXMark,
  HiPlus,
} from "react-icons/hi2";
import Modal from "../../components/Modal";
import {
  itIT,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { PersistentDataGridPro as DataGridPro } from "../../components/DataGrid/PersistentDataGridPro";
import { CustomFooterPersonalized } from "../../components/DataGrid/CustomFooterPersonalized";
const COLORI_TIPO = { Z: "#2563EB", I: "#16A66A", B: "#7C5CE7", G: "#F59E0B", non_classificati: "#94A3B8" };
const BADGE_TIPO = { Z: "bg-blue-100 text-blue-700", I: "bg-green-100 text-green-700", B: "bg-purple-100 text-purple-700", G: "bg-amber-100 text-amber-700" };
const numeroCedolini = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 3 });
const confrontaScadenzaConsegna = (a, b) => String(a ?? "").trim().localeCompare(
  String(b ?? "").trim(), "it", { numeric: true, sensitivity: "base" }
);
export const ReferentiPaghe = ({ screenSize, f24, dataF24 }) => {
  const [utenti, setUtenti] = useState([]);
  const [utenteSel, setUtenteSel] = useState(null);
  const [data, setData] = useState(
    moment(new Date()).subtract(1, "months").format("YYYY-MM")
  );
  const [parcellazione, setParcellazione] = useState([]);
  const [parcellazioneAttive, setParcellazioneAttive] = useState([]);
  const [aziende, setAziende] = useState([]);
  const [aziendaSel, setAziendaSel] = useState(null);
  const [tipoOrdinamento, setTipoOrdinamento] = useState(true);
  const [tipoGrafico, setTipoGrafico] = useState(true);
  const [barSel, setBarSel] = useState(null);
  const [dettaglioReferente, setDettaglioReferente] = useState(null);
  const [meseSel, setMeseSel] = useState(null);
  const [loadingStats, setLoadingStats] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingExportMensile, setLoadingExportMensile] = useState(false);
  const [loadingExportAggregato, setLoadingExportAggregato] = useState(false);
  const richiestaStatistiche = useRef(0);
  const tipiGrafico = ["Z", "I", "B", "G", ...(parcellazione.some(r => Number(r.cedolini_non_classificati) || Number(r.clienti_non_classificati)) ? ["non_classificati"] : [])];

  useEffect(() => {}, [screenSize]);

  useEffect(() => {
    loadstats(data);
  }, [data]);

  useEffect(() => {
    if (dettaglioReferente) {
      document.getElementById("modal_referente").click();
    }
  }, [dettaglioReferente]);

  const loadstats = async (data) => {
    const richiesta = ++richiestaStatistiche.current;
    try {
      setLoadingStats(true);
      const parc = await api.get(`/parcellazione/statistiche/referenti_paghe`, {
        params: { data: data },
      });
      if (richiesta !== richiestaStatistiche.current) return;
      setParcellazione(parc.data.map(r => ({ ...r, ...Object.fromEntries(Object.keys(COLORI_TIPO).flatMap(tipo => [
        [`cedolini_${tipo}`, Number(r[`cedolini_${tipo}`] || 0)],
        [`clienti_${tipo}`, Number(r[`clienti_${tipo}`] || 0)],
      ])) })));
      /*  if (!tipoGrafico) { //Commento perchè non devo più riordinare
        setParcellazione(
          parc.data.sort(
            (a, b) => b.cedolini_proporzionati - a.cedolini_proporzionati
          )
        );
      } else {
        setParcellazione(
          parc.data.sort((a, b) => b.cedolini_elaborati - a.cedolini_elaborati)
        );
      } */
    } catch (error) {
      if (richiesta === richiestaStatistiche.current) {
        setParcellazione([]);
        toast.error("Errore durante il caricamento delle statistiche referenti");
      }
    } finally {
      if (richiesta === richiestaStatistiche.current) setLoadingStats(false);
    }
  };

  const handleBarClick = async (el, index) => {
    try {
      setLoadingDetail(true);
      const parc = await api.get(
        `/parcellazione/statistiche/referenti_paghe/${el.referente}`,
        { params: { data: data } }
      );
      setDettaglioReferente(parc.data);
      setBarSel(index);
    } finally {
      setLoadingDetail(false);
    }
  };

  const handleChangeView = () => {
    if (tipoOrdinamento) {
      //allora è alfabetico
      setParcellazione(
        parcellazione.sort((a, b) => a.nome.localeCompare(b.nome))
      );
    } else {
      setParcellazione(
        !tipoGrafico
          ? parcellazione.sort(
              (a, b) => b.cedolini_elaborati - a.cedolini_elaborati
            )
          : parcellazione.sort(
              (a, b) => b.cedolini_proporzionati - a.cedolini_proporzionati
            )
      );
    }

    setTipoGrafico(!tipoGrafico);
  };

  const CustomImageBar = ({ x, y, width, value, payload }) => {
    const radius = 29; // Raggio del cerchio
    y = y + 20;

    const handleImageClick = (e) => {
      e.stopPropagation();

      // Trova il referente usando il nome o il codice referente dal payload
      if (payload) {
        const refIndex = parcellazione.findIndex(
          p => p.nome === payload.nome || p.referente === payload.referente
        );

        if (refIndex !== -1) {
          handleBarClick(parcellazione[refIndex], refIndex);
        }
      }
    };

    return (
      <g
        style={{ cursor: 'pointer' }}
        onClick={handleImageClick}
      >
        <circle cx={x + width} cy={y} r={radius} fill="#8884d8" />
        <text x={x + width + radius + 12} y={y} dominantBaseline="middle" textAnchor="start" fill="#1E293B" fontSize={14} fontWeight={700}>
          {numeroCedolini.format(Number((tipoGrafico ? payload?.cedolini_elaborati : payload?.cedolini_proporzionati) || 0))}
        </text>
        <clipPath id={`clip-${x}-${y}`}>
          <circle cx={x + width} cy={y} r={radius} />
        </clipPath>
        <image
          x={x + width - radius}
          y={y - radius}
          width={radius * 2}
          height={radius * 2}
          href={value}
          clipPath={`url(#clip-${x}-${y})`}
        />
      </g>
    );
  };

  const CustomYAxisTick = ({ x, y, payload, index }) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={4}
          textAnchor="end"
          fill="#666"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            const referente = parcellazione.find(p => p.nome === payload.value);
            if (referente) {
              const refIndex = parcellazione.findIndex(p => p.nome === payload.value);
              handleBarClick(referente, refIndex);
            }
          }}
        >
          {payload.value}
        </text>
      </g>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="rounded-xl border border-blue-100 bg-white p-3 shadow-lg">
          <div>
            <p className="font-bold">{`${label}`}</p>
          </div>
          <div>{`${payload[0].payload.totale_aziende} aziende gestite`}</div>
          <div>
            {numeroCedolini.format(tipoGrafico ? payload[0].payload.cedolini_elaborati : payload[0].payload.cedolini_proporzionati) +
              " Cedolini" +
              (tipoGrafico ? " Effettivi " : " Proporzionati ")}
          </div>
          <div>
            {`Percentuale Orario: ${payload[0].payload.percentuale_orario || 0}%`}
          </div>
          {tipoGrafico && <table className="mt-2 w-full border-t border-slate-100 text-sm"><thead><tr><th className="pt-2 text-left">Tipo</th><th className="pl-4 pt-2 text-right">Cedolini</th><th className="pl-4 pt-2 text-right">Clienti</th></tr></thead><tbody>{tipiGrafico.map(tipo => <tr key={tipo} style={{ color: COLORI_TIPO[tipo] }}><td>{tipo === "non_classificati" ? "Non classificati" : tipo}</td><td className="pl-4 text-right font-semibold">{numeroCedolini.format(payload[0].payload[`cedolini_${tipo}`])}</td><td className="pl-4 text-right">{numeroCedolini.format(payload[0].payload[`clienti_${tipo}`])}</td></tr>)}</tbody></table>}
        </div>
      );
    }

    return null;
  };

  const handleDownloadReportMensile = async () => {
    try {
      setLoadingExportMensile(true);
      let response = await api.post(
        `/parcellazione/statistiche/referenti_paghe/export`,
        { data: data },
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "" })
      ); //prendo il file, lo rendo blob lo aggancio a un link e scarico

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "referenti.xlsx");
      document.body.appendChild(link);
      link.click();
      toast.success("download eseguito con successo");
    } catch {
      toast.error("errore nel download dei documenti");
    } finally {
      setLoadingExportMensile(false);
    }
  };

  const handleDownloadReportAggregato = async () => {
    try {
      setLoadingExportAggregato(true);
      let response = await api.post(
        `/parcellazione/statistiche/referenti_paghe/export_aggregato`,
        { data: data },
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "" })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "referenti_aggregato.xlsx");
      document.body.appendChild(link);
      link.click();
      toast.success("download eseguito con successo");
    } catch {
      toast.error("errore nel download dei documenti");
    } finally {
      setLoadingExportAggregato(false);
    }
  };

  const handleChangeOrdinamento = () => {
    let new_ordinamento = !tipoOrdinamento;
    setTipoOrdinamento(new_ordinamento);
    if (new_ordinamento) {
      //allora è alfabetico
      setParcellazione(
        parcellazione.sort((a, b) => a.nome.localeCompare(b.nome))
      );
    } else {
      setParcellazione(
        tipoGrafico
          ? parcellazione.sort(
              (a, b) => b.cedolini_elaborati - a.cedolini_elaborati
            )
          : parcellazione.sort(
              (a, b) => b.cedolini_proporzionati - a.cedolini_proporzionati
            )
      );
    }
  };

  return (
    <div className="el-container h-fit ">
      <CustomModal
        dettaglio_referente={dettaglioReferente}
        referente={parcellazione[barSel]}
        data={data}
      />
      <div className="flex min-w-0 flex-wrap items-end gap-2">
        <div className="flex w-full min-w-0 shrink-0 items-center gap-1 sm:w-64">
          <button type="button" aria-label="Mese precedente" onClick={() => setData(moment(`${data}-01`).subtract(1, "month").format("YYYY-MM"))} className="h-10 w-10 shrink-0 rounded-lg border border-blue-200 text-xl text-blue-600 hover:bg-blue-50">‹</button>
          <input
            type="month"
            name="Data"
            value={data}
            onChange={(e) => setData(e.target.value)}
            className="h-10 min-w-0 flex-1 rounded-md border border-gray-300 p-2 focus:outline-success-200"
          />
          <button type="button" aria-label="Mese successivo" onClick={() => setData(moment(`${data}-01`).add(1, "month").format("YYYY-MM"))} className="h-10 w-10 shrink-0 rounded-lg border border-blue-200 text-xl text-blue-600 hover:bg-blue-50">›</button>
        </div>
        <Button
          text={tipoGrafico ? "Effettivi" : "Proporzionati"}
          className="success-button shrink-0 whitespace-nowrap"
          type="button"
          icon={<MdChangeCircle className="button-icon" />}
          onClick={handleChangeView}
        />
        <Button
          text={"Report referenti"}
          className="success-button shrink-0 whitespace-nowrap"
          type="button"
          icon={loadingExportAggregato ? <CircularProgress size={20} className="text-white" /> : <MdDownload className="button-icon" />}
          onClick={handleDownloadReportAggregato}
          disabled={loadingExportAggregato}
        />
        <Button
          text={"Report sing. aziende"}
          className="success-button shrink-0 whitespace-nowrap"
          type="button"
          icon={loadingExportMensile ? <CircularProgress size={20} className="text-white" /> : <MdDownload className="button-icon" />}
          onClick={handleDownloadReportMensile}
          disabled={loadingExportMensile}
        />
        <Button
          text={tipoOrdinamento ? "Alfabetico" : "Cedolino"}
          className="success-button shrink-0 whitespace-nowrap"
          type="button"
          icon={
            tipoOrdinamento ? (
              <MdGroups className="button-icon" />
            ) : (
              <MdFileOpen className="button-icon" />
            )
          }
          onClick={handleChangeOrdinamento}
        />
      </div>

      <section className="mt-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="text-lg font-bold text-slate-800">Andamento referenti · {moment(`${data}-01`).locale("it").format("MMMM YYYY")}</h3>
        <p className="mb-4 text-sm text-slate-500">{tipoGrafico ? "Cedolini effettivi di allineamento, suddivisi per tipologia" : "Cedolini proporzionati all’orario di lavoro"}</p>
        {loadingStats || loadingDetail ? <div className="flex h-80 items-center justify-center"><CircularProgress size={60}/></div> : (
          <div className="max-h-[90vh] overflow-auto">
            <div style={{ height: Math.max(300, parcellazione.length * 60 + 70), minWidth: 650 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart layout="vertical" data={parcellazione} margin={{ top: 28, right: 160, left: 80, bottom: 15 }} barCategoryGap="28%">
                  <CartesianGrid horizontal={false} stroke="#E7EDF5" strokeDasharray="3 4"/>
                  <XAxis type="number" axisLine={false} tickLine={false} tick={{ fill: "#64748B", fontSize: 12 }} tickFormatter={value => numeroCedolini.format(value)}/>
                  <YAxis type="category" dataKey="nome" axisLine={false} tickLine={false} tick={<CustomYAxisTick />}/>
                  <Tooltip cursor={{ fill: "#EFF6FF" }} content={<CustomTooltip />}/>
                  {tipoGrafico && <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }}/>}
                  {(tipoGrafico ? tipiGrafico : ["proporzionati"]).map((tipo, index, serie) => (
                    <Bar key={tipo} barSize={40} stackId="cedolini" dataKey={tipoGrafico ? `cedolini_${tipo}` : "cedolini_proporzionati"}
                      name={tipo === "non_classificati" ? "Non classificati" : tipoGrafico ? tipo : "Cedolini proporzionati"}
                      fill={tipoGrafico ? COLORI_TIPO[tipo] : "#2563EB"} onClick={handleBarClick}
                      shape={props => <Rectangle {...props} radius={serie.slice(index + 1).every(next => !props.payload[`cedolini_${next}`]) ? [0, 10, 10, 0] : [0, 0, 0, 0]}/>}>
                      {index === serie.length - 1 && <LabelList dataKey="pic" content={props => <CustomImageBar x={props.x} y={props.y} width={props.width} value={props.value || logo} payload={parcellazione[props.index]}/>}/>}
                      {parcellazione.map((entry, rowIndex) => <Cell key={rowIndex} cursor="pointer" stroke={rowIndex === barSel ? "#1E3A8A" : "none"} strokeWidth={rowIndex === barSel ? 2 : 0}/>)}
                    </Bar>
                  ))}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

const CustomModal = ({ dettaglio_referente, referente, data }) => {
  const [open, setOpen] = useState(false);
  const [currData, setCurrdata] = useState(false);
  const [selectedF24, setSelectedF24] = useState(null);
  const [searchText, setSearchText] = useState('');

  const handleClickOpen = async () => {
    setCurrdata(ManageData(data));
    setOpen(true);
  };

  // Filtra i dati in base alla ricerca
  const filteredData = useMemo(() => {
    if (!dettaglio_referente) return [];
    if (!searchText.trim()) return dettaglio_referente;

    const searchLower = searchText.toLowerCase().trim();
    return dettaglio_referente.filter((row) => {
      const codice = row.codice_univoco_azienda?.toLowerCase() || '';
      const ragione = row.ragione_sociale?.toLowerCase() || '';
      return codice.includes(searchLower) || ragione.includes(searchLower);
    });
  }, [dettaglio_referente, searchText]);

  const columns = [
    {
      field: "codice_univoco_azienda",
      headerName: "Codice univoco Azienda",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "tipologia_fatturazione",
      headerName: "Tipo",
      width: 70,
      headerAlign: "center",
      align: "center",
      renderCell: ({ row, value }) => {
        const tipo = String(row.tipologia_fatturazione || "").trim().toUpperCase();
        return <div className="flex min-w-0 items-center gap-2">
          {BADGE_TIPO[tipo] && <span aria-label={`Tipologia ${tipo}`} title={`Tipologia ${tipo}`} className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${BADGE_TIPO[tipo]}`}>{tipo}</span>}
        </div>;
      },
    },
    {
      field: "ragione_sociale", headerName: "Ragione Sociale", flex: 1, minWidth: 240,
      headerAlign: "center", align: "center",
    },
    {
      field: "cedolini_normali",
      headerName: "Cedolini normali",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "mensilita_aggiuntive",
      headerName: "Mensilità aggiuntive",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "presenze_differite",
      headerName: "Presenza Differite",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "consegna_no_round",
      headerName: "Scadenza Consegna Paghe",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortComparator: confrontaScadenzaConsegna,
    },
    {
      field: "caricamento_presenze",
      headerName: "Modalità caricamento presenze",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ccnl",
      headerName: "CCNL",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  return (
    <>
      <Button
        id="modal_referente"
        className="hidden"
        text="Aggiungi"
        type="button"
        icon={<HiPlus className="button-icon" />}
        onClick={async () => {
          await handleClickOpen();
        }}
      />

      <Modal
        isOpen={open}
        closeButton={() => setOpen(false)}
        headerText={currData}
      >
        <div className="grid grid-cols-2 gap-4 justify-items-stretch items-center">
          <div className="col-span-2 md:col-span-1 justify-self-center">
            <img
              alt="user 5"
              src={referente?.pic ? referente.pic : logo}
              className="relative inline-block h-32 w-32 rounded-full border-2 border-white object-cover object-center hover:z-10 focus:z-10"
            />
          </div>

          <div className="col-span-2 md:col-span-1 text-lg">
            <p className="font-bold">{referente ? referente.nome : ""}</p>
            <p>
              {" "}
              Aziende Gestite: {referente ? referente.totale_aziende : ""}{" "}
            </p>
            <p>
              {" "}
              Cedolini Elaborati:{" "}
              {referente ? referente.cedolini_elaborati : ""}{" "}
            </p>
            <p>
              {" "}
              Cedolini In Proporzione:{" "}
              {referente ? referente.cedolini_proporzionati : ""}{" "}
            </p>
            <p>
              {" "}
              Percentuale Orario:{" "}
              {referente ? referente.percentuale_orario + "%" : ""}{" "}
            </p>
          </div>
        </div>

        {/* Campo di ricerca */}
        <div className="col-span-2 mt-5">
          <Input
            type="text"
            placeholder="Cerca per codice univoco o ragione sociale..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="w-full"
          />
        </div>

        <div className="col-span-2 mt-3 h-[40vh]">
          <DataGridPro
            density="compact"
            slots={{
              //toolbar: CustomToo,
              //loadingOverlay: LinearProgress,
              footer: CustomFooterPersonalized,
            }}
            slotProps={{
              footer: {
                fileName: referente?.nome + " - " + currData,
                statisticsExport: true,
              },
            }}
            //loading={loading}
            localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            rows={filteredData}
            getRowId={(r) => r.codice_univoco_azienda}
          />
        </div>
      </Modal>
    </>
  );
};

const ManageData = (data) => {
  const [anno, mese] = data.split("-");
  const mesi = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ];

  return mesi[parseInt(mese) - 1] + " " + anno;
};
